/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Typography, Paper } from "@mui/material";
import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView.tsx";

export default function PaperStyleguide() {
  return (
    <>
      <StyleguideView title={"Default"}>
        <Paper sx={{ padding: "1rem" }}>
          <Typography>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
            voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,
          </Typography>
        </Paper>
      </StyleguideView>
    </>
  );
};
